<div class="pr-tainer compliance-page">
  <div class="container">
    <div class="header-row">
      <div>
        <h3 class="page-title">Compliance Rules</h3>
        <p class="section-desc">A compliance rule is a way to evaluate patients' compliance status based on payer requirements.</p>
      </div>
    </div>
    <div class="compliance-card">
      <div class="compliance-toggle-row">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="complianceRuleEnabled">
          <span class="slider round"></span>
        </label>
        <span class="compliance-rule-title section-title">Compliance rule</span>
        <span class="compliance-actions">
          <button class="icon-btn" title="Edit configuration" (click)="editRule()">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" fill="#296fab"/>
            </svg>
          </button>
          <button class="icon-btn" title="Duplicate configuration" (click)="copyRule()">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="#296fab"/>
            </svg>
          </button>
        </span>
      </div>
      <div class="compliance-rule-body">
        <div class="compliance-when-then">
          <div class="when">
            <span class="when-title section-title">When</span>
            <p class="section-desc">
              A patient’s device usage meets or exceeds 4 hours<br>
              per day on 70 percent of 30 consecutive days<br>
              between day 1 from First therapy date and day 90.
            </p>
          </div>
          <div class="then">
            <span class="then-title section-title">Then</span>
            <ul>
              <li>Mark patient compliant.</li>
              <li>Add a task to view the compliance report.<br>With a priority of <i>Medium</i></li>
            </ul>
          </div>
        </div>
        <div class="compliance-card-footer">
          <a class="add-not-compliant-link"
             href="#"
             [class.disabled]="showNotCompliantRule"
             (click)="$event.preventDefault(); addNotCompliantRule();"
             [style.color]="showNotCompliantRule ? '#ccc' : '#296fab'"
             [style.pointerEvents]="showNotCompliantRule ? 'none' : 'auto'">
            Add patient not compliant rule
          </a>
          <a class="add-not-compliant-link"
             href="#"
             *ngIf="showNotCompliantRule"
             style="color: #ccc; margin-left: 1.5rem; cursor: default;">
            Hide patient not compliant rules
          </a>
        </div>
        <div *ngIf="showNotCompliantRule" class="not-compliant-section-row">
          <div class="not-compliant-section">
            <label class="switch">
              <input type="checkbox" [(ngModel)]="notCompliantEnabled">
              <span class="slider round"></span>
            </label>
            <div class="not-compliant-when-then">
              <div class="not-compliant-when">
                <span class="when-title section-title">When</span>
                <span class="section-desc">A patient is not compliant as of day</span>
                <input type="number" class="not-compliant-day" [(ngModel)]="notCompliantDay" min="1">
              </div>
              <div class="not-compliant-then">
                <span class="then-title section-title">Then</span>
                <span class="section-desc">Add a Patient Not Compliant task.</span>
                <div class="priority-row">
                  <span>With a priority of</span>
                  <select class="priority-select" [(ngModel)]="notCompliantPriority">
                    <option>Medium</option>
                    <option>High</option>
                    <option>Low</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="not-compliant-actions">
              <a class="btn btn-link" (click)="hideNotCompliantRule()">Cancel</a>
              <button class="btn btn-primary" (click)="saveNotCompliant()">Save</button>
              <button class="btn btn-secondary" (click)="removeNotCompliant()">Remove</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
